import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect } from 'react'
import { Col, Container, Image, Row } from 'react-bootstrap'
import { faCircleUser, faHome, faIcons, faMagnifyingGlass, } from '@fortawesome/free-solid-svg-icons';
import { Link, useLocation, useParams } from 'react-router-dom';
import CategoryIcon from '@mui/icons-material/Category';
import { NavLink } from 'react-router-dom';

import './sidenavigation.css'


function SideNavigation() {

  
    const location = useLocation();
    const pathname = location.pathname
    const segment = pathname.split('/')
    const id = segment[2] !== undefined ? segment[2] : 0;
    useEffect(() => { 
        console.log(pathname);
      
        console.log(id);
        
      
    })

    const user_id = localStorage.getItem('dastaan__user_id') !== null ? localStorage.getItem('dastaan__user_id') : null

    return (
        /*     <aside className="sidebar">
               
                <div className="sidebar-logo">
                    <Image src={`${process.env.PUBLIC_URL}/favicon.png`} className='logo' alt="logo" title="Dastaan" />
                </div>
    
             
                <nav className="sidebar-icons">
                    <button className="icon active">
                        <FontAwesomeIcon className={pathname == '/' ? 'menu-active-color' : 'text-white'} icon={faHome} />
                    </button>
                    <button className="icon">
                        <FontAwesomeIcon className={pathname == '/' ? 'menu-active-color' : 'text-white'} icon={faHome} />        </button>
                    <button className="icon">
                        <FontAwesomeIcon className={pathname == '/' ? 'menu-active-color' : 'text-white'} icon={faHome} />        </button>
                    <button className="icon">
                        <FontAwesomeIcon className={pathname == '/' ? 'menu-active-color' : 'text-white'} icon={faHome} />        </button>
                </nav>
            </aside> */


        <div className="sidebar d-flex flex-column align-items-center bg-dark text-white py-4">
            <div className="sidebar-logo">
                <Link to="/" className='p-2'>
                    <Image src={`${process.env.PUBLIC_URL}/favicon.png`} className='logo' alt="logo" title="Dastaan" />
                </Link>
            </div>

            <ul className="nav flex-column">

                <li className="nav-item mb-4 position-relative menu-item">
                    <NavLink to='/' className="nav-link text-white d-flex justify-content-center">
                        <FontAwesomeIcon className={`${(pathname === '/' || pathname === `/audio-file-detail/${id}`) ? 'sidenav-menu-active-color' : 'inactive-menu'} menu-icon `} icon={faHome} />
                        <span className="menu-label text-white px-2 py-1 rounded shadow-sm">Home</span>
                    </NavLink>
                </li>
                 <li className="nav-item mb-4 position-relative menu-item">
                    <Link to='/search' className="nav-link text-white d-flex justify-content-center">

                        <FontAwesomeIcon className={`${pathname == '/search' ? 'sidenav-menu-active-color' : 'inactive-menu'} menu-icon`} icon={faMagnifyingGlass} />
                        <span className="menu-label text-white px-2 py-1 rounded shadow-sm">Search</span>
                    </Link>
                </li>
                <li className="nav-item mb-4 position-relative menu-item">
                    <Link to='/categories' className="nav-link text-white d-flex justify-content-center">
                        <FontAwesomeIcon className={`${(segment[1] == 'categories' || segment[1] == 'category-details' )? 'sidenav-menu-active-color' : 'inactive-menu'} menu-icon`} icon={faIcons} />
                        <span className="menu-label text-white px-2 py-1 rounded shadow-sm">Categories</span>
                    </Link>
                </li>
               
            {/*     {
                    user_id > 0 && ( */}
                        <li className="nav-item mb-4 position-relative menu-item">
                            <NavLink to='/my-space' className="nav-link text-white d-flex justify-content-center">
                                <FontAwesomeIcon className={`${(
                                pathname == '/my-space'
                                || pathname == '/pages/About%20Us'
                                || pathname == '/pages/Privacy%20Policy'
                                || pathname == '/pages/Refund%20Policy'
                                || pathname == '/pages/Terms%20and%20Condition'
                                || pathname == '/Psearchdashboard'
                                || pathname == '/dashboard'
                                || pathname == '/pages/Grievance%20Policy'
                                || pathname == '/download-invoice'
                            ) ? 'sidenav-menu-active-color' : 'inactive-menu'} menu-icon`} icon={faCircleUser} />
                                <span className="menu-label">My Space</span>
                            </NavLink>
                        </li>
               {/*      )
                } */}



            </ul>
        </div>
    )
}

export default SideNavigation